import gql from 'graphql-tag';
import { apollo } from 'src/features';

const query = gql`
query DirectoriesPagination($page: Int, $pageSize: Int) {
  directoriesPagination(page: $page, pageSize: $pageSize) {
    directories {
      id
      name
      description
      teams {
        id
        name
      }
      allTeamsOn
      markers {
        id
        name
        description
        answerTemplates {
          id
          text
          value
        }
      }
      system
    }
    totalCount
    pageSize
  }
}`;

function getDirectoriesPagination(page, pageSize) {
  return apollo.client.query({
    query,
    variables: {
      page,
      pageSize,
    },
    fetchPolicy: 'network-only',
  }).then((res) => res.data.directoriesPagination);
}

export default getDirectoriesPagination;
